import i18n from "@/libs/i18n";

export default [
  {
    get header() {
      return i18n.t("incubator.NICU");
    },
    permission: "get-incubator",
    role: "Incubator",
  },
  {
    get title() {
      return i18n.t("incubator.patient-incubators");
    },
    route: "patientCardIncubators",
    icon: "UsersIcon",
    permission: "get-patientCardIncubator",
    role: "Incubator",
  },
  {
    get title() {
      return i18n.t("incubator.Incubators");
    },
    route: "incubators",
    icon: "DollarSignIcon",
    permission: "get-incubator",
    role: "Incubator",
  },
  {
    get title() {
      return i18n.t("incubator.Types");
    },
    route: "incubatorType",
    icon: "DollarSignIcon",
    permission: "get-incubatorType",
    role: "Incubator",
  },
];
